import AddToBagButton from '@ulta/components/AddToBagButton/AddToBagButton';

export default AddToBagButton;